// data for Languages Table
import languageTable1 from '../assets/images/language_table_1.png';
import languageTable2 from '../assets/images/language_table_2.png';
import languageTable3 from '../assets/images/language_table_3.png';
import languageTable4 from '../assets/images/language_table_4.png';

const mockDataLanguagesTable = [
  {
    image: languageTable1,
    item_name: 'LONDON MARKETS: FTSE 100 Scrables To Hold Onto Record, As BP Falls',
    hour: 7,
    lable: 'Fox Business',
    percent: 64,
    ratio_retweet: 66,
    img_tweeter: false,
  },
  {
    image: languageTable2,
    item_name: 'Bolsa de Londres: Indice FTSE 100 abre estavel nesta terca-feira, 16 de janeiro de 2018',
    hour: 8,
    lable: 'ADVFN (Brasil)',
    percent: 63,
    ratio_retweet: 50,
    img_tweeter: false,
  },
  {
    image: languageTable3,
    item_name: 'EI #bitcoin pierde brillo y se desinfla un 40% desde maximos',
    hour: 10,
    lable: '@expansioncom',
    percent: 63,
    ratio_retweet: 50,
    img_tweeter: true,
  },
  {
    image: languageTable4,
    item_name: 'Tesla: Bald mit neuen Allzeithochs?',
    hour: 12,
    lable: 'FinanceNachrichte',
    percent: 57,
    ratio_retweet: 23,
    img_tweeter: false,
  },
  {
    image: languageTable1,
    item_name: 'Comme chaque annee avant le nouvel an lunaire, le prix du #Bitcoin chute',
    hour: 13,
    lable: '@BitcoinTrack',
    percent: 56,
    ratio_retweet: 34,
    img_tweeter: true,
  },
];

export default mockDataLanguagesTable;
